import React from 'react';
import { Fragment } from 'react';
import { isBrowser } from 'react-device-detect';

const LabOrderDetail = (props) => {
    const {customer_description, customer_contact_phone, customer_address} = props.order;
    return(
        <div className="lab-order-const-detail">
            {isBrowser ? (
                <div>
            <div className="item-holder">
                <span className="item-title">
                    توضیحات سفارش : 
                </span>
                <span className="item-value">
                    {customer_description ?? "-"}
                </span>
            </div>
            <div className="item-holder">
                <span className="item-title">
                    شماره تماس کاربر‌ :
                </span>
                <span className="item-value">
                    {customer_contact_phone ?? "-"}
                </span>
            </div>
            </div>
            ) : (<Fragment />)}
            <div className={isBrowser ? "item-holder" : "item-holder-mobile"}>
                <span className="item-title">
                    آدرس کاربر : 
                </span>
                <span className="item-value">
                    {customer_address ?? "-"}
                </span>
            </div>
        </div>
    )
};

export default LabOrderDetail;